module.exports = __webpack_public_path__ + "fonts/5ef93800cdcc3f0bbd50c266cea5778f.svg";